import { useMutation, useQueryClient } from 'react-query';
import { API_ENDPOINTS } from './client/endpoints';
import { uploadClient } from './client/upload';
import { useEffect, useState } from 'react';

// Define a shared key for the upload mutation
export const UPLOAD_MUTATION_KEY = 'upload';

export const useUploadMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    UPLOAD_MUTATION_KEY,
    (input: any) => {
      return uploadClient.upload(input);
    },
    {
      // Always refetch after error or success:
      onSettled: () => {
        queryClient.invalidateQueries(API_ENDPOINTS.SETTINGS);
      },
    }
  );
};

// Add a new hook to get the mutation state
export const useUploadMutationState = () => {
  const queryClient = useQueryClient();
  const [state, setState] = useState(
    queryClient.getMutationCache().find({ mutationKey: UPLOAD_MUTATION_KEY })
      ?.state
  );

  useEffect(() => {
    const unsubscribe = queryClient.getMutationCache().subscribe(() => {
      setState(
        queryClient
          .getMutationCache()
          .find({ mutationKey: UPLOAD_MUTATION_KEY })?.state
      );
    });

    return () => {
      unsubscribe();
    };
  }, [queryClient]);

  return state;
};
